import type { StaticAssetComponent } from '@cli-types/next-adapter/commands.js'
import { getStaticAssetComponentEntries } from './get-static-asset-component-entries.js'
export function getStaticCustomComponentEntries(): StaticAssetComponent[] {
  return getStaticAssetComponentEntries('custom')
}
